/** Random identifiers for the client identity (spec §2.1). */

function randomBytes(n: number): Uint8Array {
  const bytes = new Uint8Array(n);
  globalThis.crypto.getRandomValues(bytes);
  return bytes;
}

function hex(bytes: Uint8Array): string {
  let out = '';
  for (const b of bytes) out += b.toString(16).padStart(2, '0');
  return out;
}

/**
 * RFC 4122 v4 uuid. `crypto.randomUUID` only exists in secure contexts (https / localhost), so
 * plain-http LAN access falls back to `getRandomValues`, which is available everywhere.
 */
export function uuidV4(): string {
  const c = globalThis.crypto as Crypto | undefined;
  if (c && typeof c.randomUUID === 'function') {
    try {
      return c.randomUUID();
    } catch {
      // insecure context: fall through
    }
  }
  const b = randomBytes(16);
  b[6] = ((b[6] ?? 0) & 0x0f) | 0x40;
  b[8] = ((b[8] ?? 0) & 0x3f) | 0x80;
  const h = hex(b);
  return `${h.slice(0, 8)}-${h.slice(8, 12)}-${h.slice(12, 16)}-${h.slice(16, 20)}-${h.slice(20)}`;
}

/** `bytes` random bytes as lowercase hex (32 bytes → 64 chars). */
export function randomHex(bytes = 32): string {
  return hex(randomBytes(bytes));
}

export const UUID_V4_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
/** Server rule for `playerToken`: 16–128 chars of `[A-Za-z0-9_-]`. */
export const PLAYER_TOKEN_RE = /^[A-Za-z0-9_-]{16,128}$/;
